module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'page-nav/sides' && templateVars.config ?
				templateVars.config :
				{
	"titleParam": "shortTitle",
	"deactivateBtn": "deactivate"
};


//////////////////
// WEBPACK FOOTER
// ./temp/components/page-nav/.variant/sides/config.yaml
// module id = 108
// module chunks = 0